<template>
  <div>
    <Pane />

    <div class="container">
      <a-form
        :form="form"
        @submit="handleSubmit"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
      >
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="客商名称">
              <a-input
                v-decorator="[
                  'suppName',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入！',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="客商编码">
              <a-input v-decorator="['suppCode']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="手机号">
              <a-input v-decorator="['contactMobile']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="联系邮箱">
              <a-input v-decorator="['contactEmail']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="办公电话">
              <a-input v-decorator="['officeTel']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="客户类型">
              <a-select v-decorator="['custType']" placeholder="请选择" allow-clear>
                <a-select-option v-for="item in clientTypeDict" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="客户状态">
              <a-select v-decorator="['custStatus']" placeholder="请选择" allow-clear>
                <a-select-option v-for="item in clientStatusDict" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="经营状态">
              <a-select v-decorator="['supplierStatus']" placeholder="请选择" allow-clear>
                <a-select-option v-for="item in supplierStatusDict" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="客户类别">
              <a-select v-decorator="['custCategory']" placeholder="请选择" allow-clear>
                <a-select-option v-for="item in clientTypeDict" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="供应商类型">
              <a-select v-decorator="['supplierType']" placeholder="请选择" allow-clear>
                <a-select-option v-for="item in supplierTypeDict" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="管理组织">
              <a-input v-decorator="['orgName']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="证件类型">
              <a-select v-decorator="['docType']" placeholder="请选择" allow-clear>
                <a-select-option v-for="item in idTypeDict" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="纳税人类型">
              <a-select v-decorator="['taxType']" placeholder="请选择" allow-clear>
                <a-select-option v-for="item in taxTypeDict" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="证件号码">
              <a-input v-decorator="['docNum']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="注册资金">
              <a-input v-decorator="['regCap']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="注册币种">
              <a-select v-decorator="['regCurName']" placeholder="请选择">
                <a-select-option value="人民币">人民币</a-select-option>
                <a-select-option value="美元">美元</a-select-option>
                <a-select-option value="欧元">欧元</a-select-option>
                <a-select-option value="港币">港币</a-select-option>
                <a-select-option value="日元">日元</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="所属国家">
              <a-input v-decorator="['countryName']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="集团客户ID">
              <a-input v-decorator="['custId']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="集团系统编码">
              <a-input v-decorator="['sysId']" />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="所在地">
              <a-cascader
                v-decorator="['location']"
                :options="cityList"
                placeholder="请选择"
                :fieldNames="{ label: 'name', value: 'name', children: 'children' }"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="注册地址">
              <a-input v-decorator="['regAddr']" />
            </a-form-item>
          </a-col>

          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item
              label="银行"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <Bank
                :list="bankList"
                :readonly="true"
                @addBank="addBank"
                @setBank="setBank"
                @removeBank="removeBank"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <div class="center">
          <a-space>
            <a-button htmlType="submit" type="primary">保存</a-button>
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { add } from "@/api/setting/supplier";
import city from "@/mixins/city";

import Bank from "../company/components/bank.vue";
export default {
  name: "addSupplier",

  mixins: [city],

  components: {
    Bank,
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),

    clientTypeDict() {
      return this.findDataDict("client_supplier.client_type");
    },
    clientStatusDict() {
      return this.findDataDict("client_supplier.client_status");
    },
    idTypeDict() {
      return this.findDataDict("client_supplier.id_type");
    },
    supplierStatusDict() {
      return this.findDataDict("client_supplier.supplier_status");
    },
    supplierTypeDict() {
      return this.findDataDict("client_supplier.supplier_type");
    },
    taxTypeDict() {
      return this.findDataDict("client_supplier.tax_type");
    },
  },

  data() {
    return {
      form: this.$form.createForm(this),

      bankList: [
        {
          editable: true,
        },
      ],
    };
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          const { location, ...rest } = values;
          const submitData = {
            ...rest,
            banks: this.bankList
              .filter(
                (item) => item.accName && item.bankAccNum
              )
              .map((item) => {
                return {
                  ...item,
                  editable: undefined,
                };
              }),
          };
          if (location && location.length >= 1) {
            const province = this.rawCityList.find(item => item.name === location[0] && item.pid === null);
            submitData.provinceName = location[0];
            submitData.provinceCode = province ? province.id : '';
          }
          if (location && location.length >= 2) {
            const provinceId = this.rawCityList.find(item => item.name === location[0] && item.pid === null)?.id;
            const city = this.rawCityList.find(item => item.name === location[1] && item.pid === provinceId);
            submitData.cityName = location[1];
            submitData.cityCode = city ? city.id : '';
          }
          if (location && location.length >= 3) {
            const provinceId = this.rawCityList.find(item => item.name === location[0] && item.pid === null)?.id;
            const cityId = this.rawCityList.find(item => item.name === location[1] && item.pid === provinceId)?.id;
            const district = this.rawCityList.find(item => item.name === location[2] && item.pid === cityId);
            submitData.districtName = location[2];
            submitData.districtCode = district ? district.id : '';
          }
          if (submitData.regCurName) {
            const curMap = { '人民币': 'CNY', '美元': 'USD', '欧元': 'EUR', '港币': 'HKD', '日元': 'JPY' };
            submitData.regCurCode = curMap[submitData.regCurName] || '';
          }
          add(submitData).then(() => {
            this.form.resetFields();
            this.bankList = [
              {
                editable: true,
              },
            ];
          });
        }
      });
    },

    addBank() {
      this.bankList.push({
        editable: true,
      });
    },

    setBank({ index, element }) {
      this.bankList.splice(index, 1, element);
    },

    removeBank(index) {
      this.bankList.splice(index, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.center {
  margin-top: 80px;
}
</style>
